import SETTINGS from "./../settings.json";

 function createLead(firstName, lastName, phone, email, Company, JobTitle) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify([
    {
      Attribute: "FirstName",
      Value: firstName,
    },
    {
      Attribute: "LastName",
      Value: lastName,
    },
    {
      Attribute: "EmailAddress",
      Value: email,
    },
    {
      Attribute: "Phone",
      Value: phone,
    },
    {
      Attribute: "Company",
      Value: Company,
    },
    {
      Attribute: "JobTitle",
      Value: JobTitle,
    },
  ]);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  fetch(
    `${SETTINGS.host}LeadManagement.svc/Lead.Capture?accessKey=${SETTINGS.accessKey}&secretKey=${SETTINGS.secretKey}`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      if (Company == "leadsquared") {
        postVisitActivityV2(email, "Granted");
      } else {
        postVisitActivityV2(email, "Denied");
      }
    })
    .catch((error) => console.log("error", error));
}

export async function getUserInfo(accessToken) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${accessToken}`);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  fetch("https://graph.microsoft.com/v1.0/me", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      createLead(
        result.givenName,
        result.surname,
        result.mobilePhone,
        result.mail,
        result.mail?result.mail.split("@")[1].split(".")[0]:"",
        result.jobTitle
      );
    })
    .catch((error) => console.log("error", error));
}

export async function postSearchActivity(email, key) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify([
    {
      SearchByValue: email,
      ActivityEvent: 201,
      ActivityNote: "External Tools screen used to search: "+key,
      Fields: [
        {
          SchemaName: "mx_Custom_1",
          Value: key,
        },
      ],
    },
  ]);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  if(key.length>0)
  fetch(
    `${SETTINGS.host}ProspectActivity.svc/Bulk/CustomActivity/Add/ByLeadField?accessKey=${SETTINGS.accessKey}&secretKey=${SETTINGS.secretKey}&searchBy=EmailAddress`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => (result))
    .catch((error) => console.log("error", error));
}

export async function postVisitActivityV2(email, access) {
  let d = new Date();
  let datetime = d.toLocaleString();
  let date =datetime? datetime.split(" ")[0]:"";
  let time =datetime? datetime.split(" ")[1]:"";
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify([
    {
      SearchByValue: email,
      ActivityEvent: 200,
      ActivityNote: "External Tools Opened",
      Fields: [
        {
          SchemaName: "mx_Custom_1",
          Value: date,
        },
        {
          SchemaName: "mx_Custom_2",
          Value: time,
        },
        {
          SchemaName: "mx_Custom_3",
          Value: access,
        },
      ],
    },
  ]);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(
    `${SETTINGS.host}ProspectActivity.svc/Bulk/CustomActivity/Add/ByLeadField?accessKey=${SETTINGS.accessKey}&secretKey=${SETTINGS.secretKey}&searchBy=EmailAddress`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => (result))
    .catch((error) => console.log("error", error));
}
